export default __webpack_public_path__ + "static/media/planet2.d480e7f7.webp";